import { Component, Inject, OnInit, ViewChild, EventEmitter} from '@angular/core';
import { HandlerModal } from '../../handler-modals';
import { DAyudasFormularioNoExperto } from '../../../../../../configuracion/dayudas-formulario-no-experto';
import { MAT_DIALOG_DATA,MatDialogRef } from '@angular/material';
import { DDocumento } from '@dian/api-formulario';
import { DirectionType } from '../../handler-modals';
import { DOperacionesMatematicasServicio, DTipoOperacionAritmetica } from '@dian-cmp/formulario';
import { DNotificacionServicio } from '@dian-cmp/notificaciones';

const VAL_INDICADOR_COMPLETO="999";//Valor de referencia, si el indicador esta en este valor entonces ya paso todos los steps y el modal esta completo
const ID_CAS_INDICADOR_AVANCE='cs_id_228';

const stepsList = [
  { text: "1", active: false, completed: false, tooltip: 'Ingrese valor si tuvo saldo a favor en la declaración de renta del año anterior', listHelp: ['808'] }];


const tableStructure = [
   {id: 'valDeclaradoAnioAnterior', title: 'Saldo a favor declaración año anterior'},
];

class ArticulosDominio {
  valor: number;
  nombre: string;
}

class Form1 {
id: number;
valDeclaradoAnioAnterior: string;

}
@Component({
  selector: 'app-impuesto-renta-impto-renta-saldo-a-favor-ano-anterior-modal',
  templateUrl: './impto-renta-saldo-a-favor-ano-anterior-modal.component.html',
  styleUrls: ['./impto-renta-saldo-a-favor-ano-anterior-modal.component.css'],
  providers: [
    DNotificacionServicio,
    DOperacionesMatematicasServicio
  ]
})
export class ImpuestoRentaSaldoaFavorDeclaracionAñoAnteriorModalComponent extends HandlerModal implements OnInit {
  public dataSourceHeader = tableStructure;
  public dataSourceBody = [];
  public modelForm: Form1 = new Form1();
  public lstArticulos: ArticulosDominio[] = [];
  public OPERACION_NULA:number = 0;
  public OPERACION_AGREGAR:number = 1;
  public OPERACION_EDITAR:number = 2;
  public OPERACION_BORRAR:number = 3; 
  public operacionTabla:number = this.OPERACION_NULA;
  mensajeTabla = "Agregue o modifique el saldo a favor del año anterior";

  @ViewChild('buttonRight') buttonRight: any;
  saveModel = new EventEmitter();
  public showSave:boolean;

  constructor(
    public dialogRef: MatDialogRef<ImpuestoRentaSaldoaFavorDeclaracionAñoAnteriorModalComponent>,
    public dutilidades:DOperacionesMatematicasServicio, 
    public dNotificacionServicio: DNotificacionServicio,
    @Inject(MAT_DIALOG_DATA) public model: DDocumento
  ) { 
    super(stepsList, DAyudasFormularioNoExperto.AYUDAS_FORMULARIO);
    console.log(model);
  }

  ngOnInit() {
    this.inicializeModelo();
    this.inicializeForm();
    this.initializeTablaDesdeModelo();
   /*  this.validateBtnRightActive();
    this.validateShowSave(); */
  }

  protected inicializeForm(){
    this.modelForm = new Form1();
    this.modelForm.id=0;
    this.modelForm.valDeclaradoAnioAnterior="0";
  //  this.reloadSelArticulos();
  }
  

  protected inicializeModelo(){
    if(this.model.doc.cuerpo.cs_id_810 == undefined){
      this.model.doc.cuerpo.cs_id_810 = "0";
   
    }  
  }

  // protected reloadSelArticulos(conservarArt?:boolean){//Dom 1649
    
  //   this.lstArticulos[0] = {valor:0,nombre:""};
  //   this.lstArticulos[1] = {valor:1,nombre:"Valor de compra: "+this.modelForm.valCompra};
  //   this.lstArticulos[2] = {valor:2,nombre:"Valor declarado año anterior: "+this.modelForm.valDeclaradoAnioAnterior};
  //   this.lstArticulos[3] = {valor:3,nombre:"Reajuste Art. 70: "+this.modelForm.valReajuste};
    
  //   if(!conservarArt)this.modelForm.art=0;
  // }

  protected initializeTablaDesdeModelo(){
    this.dataSourceBody = [];
  
      this.modelForm.valDeclaradoAnioAnterior=this.model.doc.cuerpo.cs_id_810; 
      this.dataSourceBody.push(this.modelForm);
      //this.inicializeForm();
    
  }
  public editModeloDesdeForm(){

    if (Array.isArray(this.model.doc.cuerpo.cs_id_810)) {
      const index = Math.min(Math.max(0, this.modelForm.id), this.model.doc.cuerpo.cs_id_810.length - 1);
      this.model.doc.cuerpo.cs_id_810[index].v = this.modelForm.valDeclaradoAnioAnterior.toString();
  } else {
      console.error('Error: cs_id_810 no es un array.');
  }

    //===
  //   if (Array.isArray(this.model.doc.cuerpo.cs_id_810) && this.modelForm.id >= 0 && this.modelForm.id < this.model.doc.cuerpo.cs_id_810.length) {
  //     this.model.doc.cuerpo.cs_id_810[this.modelForm.id].v = this.modelForm.valDeclaradoAnioAnterior.toString();
  // } else {
  //     console.error('Error: Elemento no encontrado o índice inválido.');
  // }
  //=====
    
   // this.model.doc.cuerpo.cs_id_810[this.modelForm.id].v=this.modelForm.valDeclaradoAnioAnterior.toString();
    
  }
  public addToModeloDesdeForm(){
  //   let i= this.modelForm.id+1;
    
    
  //  this.model.doc.cuerpo.cs_id_810.push({it: i, v:this.modelForm.valDeclaradoAnioAnterior});
  //   console.log("valor en add de 810 :"  + this.model.doc.cuerpo.cs_id_810)
//====
  // let i = this.modelForm.id + 1;
    
  // // Verifica si cs_id_810 es un array antes de usar push
  // if (!Array.isArray(this.model.doc.cuerpo.cs_id_810)) {
  //     this.model.doc.cuerpo.cs_id_810 = []; // Inicializa como un array vacío
  // }
  
  // this.model.doc.cuerpo.cs_id_810.push({ it: i, v: this.modelForm.valDeclaradoAnioAnterior.toString() });
  // console.log("valor en add de 810: " + this.model.doc.cuerpo.cs_id_810);
  //===
  let i = this.modelForm.id + 1;
    
  // Verifica si cs_id_810 es un array antes de usar push
 // if (!Array.isArray(this.model.doc.cuerpo.cs_id_810)) {
   //   this.model.doc.cuerpo.cs_id_810 = []; // Inicializa como un array vacío
  //}
  
  // Almacena el valor en cs_id_810
  this.model.doc.cuerpo.cs_id_810 = this.modelForm.valDeclaradoAnioAnterior.toString();
  
  
  console.log("valor en add de 810: " + this.model.doc.cuerpo.cs_id_810);

  }

  public deleteOnModel(index:number){
    
    this.model.doc.cuerpo.cs_id_810.splice(index,1);


    //reenumerear it
    for(let i=0;i<this.model.doc.cuerpo.cs_id_810.length;i++){
      
      this.model.doc.cuerpo.cs_id_810[i].it=i+1;

    }
  }

  public validateFormCompleted():boolean{
    return this.modelForm.valDeclaradoAnioAnterior==undefined /* this.modelForm.valDeclaradoAnioAnterior=="0" ||  */
        
  }

  public redondearFormData(){
    
    this.modelForm.valDeclaradoAnioAnterior=this.dutilidades.redondearValorMoneda(this.modelForm.valDeclaradoAnioAnterior.toString(),true);
    
  }

   public calcularValoresForm(conservarArt?:boolean){
    this.redondearFormData();
  //   this.modelForm.valReajuste = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, this.modelForm.valDeclaradoAnioAnterior, "1.1240", true);
  //   this.modelForm.valReajuste = this.dutilidades.redondearValorMoneda(this.modelForm.valReajuste.toString(),true);

  //   switch(Number(this.modelForm.art)){
  //     case 1:
  //       this.modelForm.valDeclarar = this.modelForm.valCompra;
  //       break;
  //     case 2:
  //       this.modelForm.valDeclarar = this.modelForm.valDeclaradoAnioAnterior;
  //       break;
  //     case 3:
  //       this.modelForm.valDeclarar = this.modelForm.valReajuste;
  //       break;
  //   }
   // this.reloadSelArticulos(conservarArt);
   }


  saveItem(): void {
    if(this.validateFormCompleted()){
      let dialogError = this.dNotificacionServicio.mostrarDialogoError("Debe diligenciar todos los campos para agregar un nuevo registro" );
      return;
    }else{
      this.redondearFormData();
      if (this.operacionTabla==this.OPERACION_EDITAR){
       // this.editModeloDesdeForm();
       this.dataSourceBody.forEach((el)=>{
        if(el.id == this.modelForm.id){
          el=this.modelForm;
        }
      });
      }else if (this.operacionTabla==this.OPERACION_AGREGAR){
       // this.modelForm.id = this.dataSourceBody.length;
       this.modelForm.id = this.model.doc.cuerpo.cs_id_810;
        this.dataSourceBody.push(this.modelForm);
      //  this.addToModeloDesdeForm();
      }
      //Recalcular y reinicializar
      //this.operacionCs810();
      this.inicializeForm();
      this.operacionTabla=this.OPERACION_NULA;
     // console.log(this.model);
    }
  }

  eventTable($event: string): void {
    if($event === 'add') this.operacionTabla=this.OPERACION_AGREGAR;
    if($event === 'edit') this.operacionTabla=this.OPERACION_EDITAR;
    if($event === 'delete') this.operacionTabla=this.OPERACION_BORRAR;
    this.operacionCs152();
  }

  updateItemSelected($event: any): void {
    let index = $event;
    if(this.operacionTabla==this.OPERACION_EDITAR){//editando
      this.modelForm = this.dataSourceBody[index];
   //   this.reloadSelArticulos(true);
    }
    if(this.operacionTabla==this.OPERACION_BORRAR){//borrando
    //  this.deleteOnModel(index);
      this.operacionTabla=this.OPERACION_NULA;
    }
  }
  
  cancel(): void {
    this.inicializeForm();
    this.operacionTabla=this.OPERACION_NULA;
  }

  
  
  // public operaciones(numCas?:number,soloEstaCasilla?:boolean):void {
  //   switch (numCas) {
  //     case 152:
  //    //   this.operacionCs152();
  //       break;
  //   }
  //   if(soloEstaCasilla)return;

  //   //Operaciones
  //   let resultado = "0";
    
  //   //C151=C149-C153+C154+C155; 
  //   resultado = "0";
  //   resultado = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, this.model.doc.cuerpo.cs_id_149,this.model.doc.cuerpo.cs_id_153, true); 
  //   resultado = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, resultado,this.model.doc.cuerpo.cs_id_154, true); 
  //   resultado = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, resultado,this.model.doc.cuerpo.cs_id_155, true); 
  //   resultado = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, resultado, "0")?"0":resultado;
  //   this.model.doc.cuerpo.cs_id_151 = this.dutilidades.redondearValorMoneda(resultado,true);
    
  // }

  operacionCs152(){
    // let suma = "0";
    // for(let i=0; i<this.dataSourceBody.length; i++){
    //     suma = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA,this.dataSourceBody[i].valDeclarar, suma);
    // }
    // this.model.doc.cuerpo.cs_id_810 = suma;
    console.log("valor 810 :" + this.model.doc.cuerpo.cs_id_810)
  }
 
  protected obtenerCasIndicadorAvance():string{
    if(this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]==undefined){
      this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]="0";
    }
    return this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE];
  }
  


  protected controlStep(direction: DirectionType): void {
   
  }



  public closeModal(){
    //this.changeStepLocal(0);
    this.initializeTablaDesdeModelo();
    this.dialogRef.close("");
  }

  public guardar(){


    this.model.doc.cuerpo.cc_id_262 = undefined;
    this.inicializeModelo();
    for(let i=0; i<this.dataSourceBody.length; i++){
      this.modelForm = this.dataSourceBody[i];
      this.addToModeloDesdeForm(); 
    }
  
    this.saveModel.emit(true);
    console.log(this.modelForm)
    console.log(this.model.doc.cuerpo.cs_id_810)
    this.closeModal();

  }
}



// WEBPACK FOOTER //
// D:/GITHUB/F210/V18/rec_ng_renta210v18/src/app/components/formulario-no-experto/secciones/modales/impuesto-renta/impto-renta-saldo-a-favor-ano-anterior-modal/impto-renta-saldo-a-favor-ano-anterior-modal.component.ts